import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

interface ProgressHelper {
    height?: number;
    color?: string;
}

/**
 * 进度条
 * @returns
 */
export const useProgressHelper = (props: ProgressHelper = {}) => {
    const { height = 4, color = '#409EFF' } = props;

    NProgress.configure({
        showSpinner: false,
        minimum: 0.4,
        template: `
          <div class='bar' role='bar' style='background: ${color}; height: ${height}px;'>
            <div class'peg' style='box-shadow: 0 0 10px ${color}, 0 0 5px ${color};'></div>
          </div>
      `,
    });

    return NProgress;
};
